import NL_BE from "./NL_BE.json";
import { localStorage } from "../utils";

export const chosenLanguage = "NL_BE";

export const changeLanguage = (lang: string) => {
  localStorage.setItem("language", lang);
  window.location.reload();
};

const TRANSLATIONS = {
  NL_BE: NL_BE,
};

type TranslationRecord = { [k: string]: string | null | TranslationRecord };

/**
 * Resolve the translation
 *
 * @param key_or_keys - The key to translate, or an array of keys
 * @param interpolations - Values to be filled in the translation
 * @param language - The language to translate to
 */
export function translate(
  key_or_keys: string | Array<string>,
  interpolations: Record<string, string | number> = {},
  language: keyof typeof TRANSLATIONS = chosenLanguage,
): string | undefined {
  if (!Object.keys(TRANSLATIONS).includes(language.toUpperCase())) {
    throw new Error("Selected language does not exist");
  }

  const keys = Array.isArray(key_or_keys)
    ? key_or_keys
    : key_or_keys.split(".");
  let translation: string | undefined | null | TranslationRecord = keys.reduce(
    (scope: TranslationRecord | undefined | null | string, key) => {
      if (scope === undefined) return;
      if (scope === null) return;
      if (typeof scope === "string") return scope;

      return scope[key];
    },
    TRANSLATIONS[
      language.toUpperCase() as keyof typeof TRANSLATIONS
    ] as TranslationRecord,
  );

  if (typeof translation === "string") {
    Object.entries(interpolations).forEach(
      ([key, value]) =>
        (translation = (translation as string).replaceAll(
          `\${${key}}`,
          value.toString(),
        )),
    );
    return translation;
  }

  // This should only happen during development
  // eslint-disable-next-line no-console
  console.error(`Translation ${keys.join(".")} could not be found`);

  if (import.meta.env.DEV || import.meta.env.VITE_SHOW_MISSING_TRANSLATIONS) {
    return keys.join(".");
  }
}
